const namespaced = true
const state = {
  isShowFormula: false,
  data: null,
  newIndex: 0,
  parConfEdited: {},
  errors: {},
  errorKey: null,
  loading: false,
  error: false
}

const getters = {
  dropValues: (state) => {
    const values = ['par', 'завтал', 'waistband', 'ruffle', 'cuff', 'facing', 'lining', 'elastik', 'loop']
    if (state.data?.length) {
      state.data.forEach(el => {
        if (!Number(el.number) && !values.includes(el.number)) {
          values.push(el.number)
        }
      })
    }
    return values
  },
  filterForNumber: (state, rootGetters, rootState) => number => {
    if (state.data?.length && number) {
      const filtered = state.data.filter(el => {
        if (
          (!el.category_codes.length ||
          el.category_codes.includes(rootState.partCategories?.selectedSubCategory)) &&
          el.number.toString().toLowerCase() === number.toString().toLowerCase()
        ) {
          return el
        } else return null
      })
      return filtered
    }
  },
  sortedDataNumber: state => category => {
    if (state.data?.length) {
      const sorted = state.data
        .filter(el => {
          if (category) {
            if (
              !el.category_codes.length ||
              el.category_codes.includes(category)
            ) return el
            else return null
          } else return el
        })
      return sorted
    } else return null
  }
}
const mutations = {
  setData (state, data) {
    data.items.forEach(el => {
      if (!el.category_codes) el.category_codes = []
      el.newMeaning = []
      for (const key in el.meaning) {
        el.newMeaning.push({
          key: key,
          value: el.meaning[key] || ''
        })
      }
      return el
    })
    state.data = data.items.sort((a, b) => {
      if (
        Number(a.number) && Number(b.number) && a.number[0] !== '0' && b.number[0] !== '0'
      ) return a.number - b.number
      else return a.number < b.number ? -1 : 1
    })
    // const sorted = data.items
    //   .sort((a, b) => {
    //     // const aNumber = a.number.replace(/^0+/, '').replace(/0$/, '')
    //     // const bNumber = b.number.replace(/^0+/, '').replace(/0$/, '')
    //     // return aNumber - bNumber
    //   })
    // state.data = sorted
  },
  setError (state, { id, tag, text }) {
    if (Object.keys(state.errors).length === 0) state.errorKey = id
    if (!state.errors[id]) state.errors[id] = {}
    state.errors[id][tag] = text
  }
}
const actions = {
  validateFormula ({ state, commit }) {
    state.errors = {}
    for (const key in state.parConfEdited) {
      for (const tag in state.parConfEdited[key]) {
        // description
        if (tag === 'description' && !state.parConfEdited[key][tag]) {
          commit('setError', { id: key, tag: tag, text: 'description cannot be empty' })
        }
        // number
        if (tag === 'number' && !state.parConfEdited[key][tag]) {
          commit('setError', { id: key, tag: tag, text: 'number cannot be empty' })
        } else if (tag === 'number' && state.parConfEdited[key][tag]) {
          const categoryCodes = state.parConfEdited[key].category_codes
          state.data.forEach(el => {
            if (
              el.id !== key &&
              el.number.toString().toLowerCase() === state.parConfEdited[key][tag].toString().toLowerCase()
            ) {
              if (el.category_codes.length && categoryCodes.length) {
                const isCopyCode = []
                categoryCodes.forEach(code => {
                  if (el.category_codes.includes(code)) isCopyCode.push(code)
                })
                if (isCopyCode.length) {
                  commit('setError', {
                    id: key,
                    tag: tag,
                    text: `for the same numbers there should be different category codes. change category_codes - ${isCopyCode.toString()}`
                  })
                }
              } else {
                commit('setError', {
                  id: key,
                  tag: tag,
                  text: 'such a number already exists. add different category codes to them'
                })
              }
            }
          })
        }
        // meaning
        if (tag === 'meaning') {
          const meaning = {}
          state.parConfEdited[key][tag].forEach(el => {
            if (!el.key) commit('setError', { id: key, tag: tag, text: 'meaning key cannot be empty' })
            if (!el.value) commit('setError', { id: key, tag: tag, text: 'meaning value cannot be empty' })
            if (!meaning[el.key]) meaning[el.key] = el.value
            else {
              commit('setError', { id: key, tag: tag, text: `there cannot be identical meaninig keys - ${el.key}` })
            }
          })
        }
      }
    }
  },
  async saveFormula ({ rootState, state, dispatch, commit }) {
    await dispatch('validateFormula')
    if (Object.keys(state.errors).length) return false
    else {
      for (const key in state.parConfEdited) {
        const data = {}
        for (const tag in state.parConfEdited[key]) {
          if (tag === 'meaning') {
            data[tag] = {}
            state.parConfEdited[key][tag].forEach(el => {
              data[tag][el.key] = el.value
            })
          } else data[tag] = state.parConfEdited[key][tag]
        }
        let url = `${rootState.api.host}${rootState.api.endpoint.formula}/${key}`
        let method = 'PUT'
        if (key.includes('new')) {
          url = `${rootState.api.host}${rootState.api.endpoint.formula}`
          method = 'POST'
        }
        const putFormula = await fetch(url, {
          method: method,
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
            Authorization: 'Bearer ' + rootState.user.accesToken
          },
          body: JSON.stringify({
            ...data
          })
        })
        if (putFormula.ok) {
          delete state.parConfEdited[key]
          if (key.includes('new')) {
            const responce = await putFormula.json()
            if (responce.item.id) {
              state.data.forEach(el => {
                if (el.id === key) {
                  el.id = responce.item.id
                }
              })
            }
          }
        }
      }
      if (Object.keys(state.parConfEdited).length === 0) {
        state.data.sort((a, b) => {
          if (
            Number(a.number) && Number(b.number) && a.number[0] !== '0' && b.number[0] !== '0'
          ) return a.number - b.number
          else return a.number < b.number ? -1 : 1
        })
        commit('notifications/addNotification', {
          notification: {
            type: 'success',
            message: 'Saving was successful'
          }
        }, { root: true })
      } else {
        commit('notifications/addNotification', {
          notification: {
            type: 'danger',
            message: 'Something went wrong. Try saving again.'
          }
        }, { root: true })
      }
    }
  },
  async deleteFormula ({ state, rootState, commit }, id) {
    if (id.toString().includes('new')) {
      const index = state.data.findIndex(el => el.id === id)
      state.data.splice(index, 1)
      delete state.parConfEdited[id]
      state.errors = {}
    } else {
      const formula = await fetch(`${rootState.api.host}${rootState.api.endpoint.formula}/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      })
      if (formula.ok) {
        const index = state.data.findIndex(el => el.id === id)
        state.data.splice(index, 1)
        commit('notifications/addNotification', {
          notification: {
            type: 'success',
            message: 'Removal was successful'
          }
        }, { root: true })
      } else {
        commit('notifications/addNotification', {
          notification: {
            type: 'danger',
            message: 'Something went wrong. Try deleting again.'
          }
        }, { root: true })
      }
    }
  },
  putParEdited ({ state }, { id, data, tag }) {
    if (!state.parConfEdited[id]) state.parConfEdited[id] = {}
    state.parConfEdited[id][tag] = data
  },
  async getFormula ({ state, rootState, commit }) {
    state.error = false
    state.loading = true
    const formula = await fetch(`${rootState.api.host}${rootState.api.endpoint.formula}`, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootState.user.accesToken
      }
    })
    state.loading = false
    if (formula.ok) {
      const data = await formula.json()
      if (data) commit('setData', data)
    } else {
      state.error = true
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced
}
